/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon20Regular = forwardRef('ArrowRoundTimeForwardIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.431 3.974a6.498 6.498 0 1 0 3.421 8.852.75.75 0 1 1 1.351.652 7.998 7.998 0 1 1-.703-8.14V2.756a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75H13a.75.75 0 0 1 0-1.5h2.479a6.498 6.498 0 0 0-3.047-2.531Z" })));
});
